import { call, put } from 'redux-saga/effects';

import { cultureAsync } from '../services/settingsServices';

import {
  setCulturesSuccess,
  setShowEntities,
  getGsModuleActiveSuccess,
} from '../actions/settingsActions';

export function* culture() {
  try {
    const culture = yield call(cultureAsync);
    yield put(setCulturesSuccess(culture));
  } catch (err) {
    console.error(err);
  }
}

export function* gsModuleActive() {
  try {
    // const active = yield call(gsModuleActiveAsync);
    const active = false;
    yield put(getGsModuleActiveSuccess({ active }));
  } catch (err) {
    console.error(err);
  }
}

export function* showEntities(payload) {
  try {
    yield put(setShowEntities(payload));
  } catch (err) {
    console.error(err);
  }
}
